import checkRetractionForErrors from "~/store/manage/validation/checkRetractionForErrors";

const UPDATE_RETRACTION_RESPONSE = (state, payload) => {
  state.retractionItem.retraction.response[payload.field] = payload.value;

  state.retractionErrors = checkRetractionForErrors(state.retractionItem);
};

export default UPDATE_RETRACTION_RESPONSE;
